module.exports = __webpack_public_path__ + "media/maps/download-578bdf57.svg";